"use strict";

exports.__esModule = true;
exports.toast = exports.ToastContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactToastify = require("react-toastify");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * The Toast component is used to display some information to the user in a <strong>non-obtrusive</strong> way.
 * A Toast is displayed for a short period of time and typically contain system's feedback to user's interactions.
 *
 * If you want a way to prevent the user to interact with the page before taking action, use a Modal component instead.
 * If you want to force the user to interact with it, use a Alert component instead.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/fkhadra/react-toastify">ReactToastify</a>.
 */
var Message = function Message(_ref) {
  var children = _ref.children;
  if (!children) return null;
  if (typeof children === 'string') {
    return /*#__PURE__*/_react.default.createElement("span", null, children);
  }
  if (children.constructor === Array) {
    return /*#__PURE__*/_react.default.createElement("ul", null, children.map(function (item, i) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i
      }, item.message);
    }));
  }
  return children;
};
Message.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.element])
};
var displayToast = function displayToast(method, children) {
  _reactToastify.toast[method]( /*#__PURE__*/_react.default.createElement(Message, null, children));
};
var toast = exports.toast = {
  info: function info(children) {
    return displayToast('info', children);
  },
  error: function error(children) {
    return displayToast('error', children);
  },
  success: function success(children) {
    return displayToast('success', children);
  },
  warn: function warn(children) {
    return displayToast('warn', children);
  }
};
var ToastContainer = exports.ToastContainer = function ToastContainer() {
  return /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, {
    icon: false,
    className: "uk-toast-wrapper",
    toastClassName: "uk-toast"
  });
};